import {
	AfterViewChecked,
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	Inject,
	Input
} from '@angular/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { helpUrlsLookup } from 'go-modules/help-urls/help-urls.constant';
import { Reasons } from 'go-modules/video-scene/state-emitter/state-emitter';
import { CONTINUE_WITHOUT_AUDIO_KEY } from 'go-modules/video-scene/constants';

export interface StatusOverlayable {
	readonly reason: Reasons;
	readonly browser?: string;
	readonly action: (options?: object) => void;
}

@Component({
	selector: 'status-overlay',
	templateUrl: './status-overlay.component.html',
	styleUrls: ['./status-overlay.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class StatusOverlayComponent implements AfterViewChecked {
	@Input() public status: StatusOverlayable;
	public helpUrls = helpUrlsLookup;
	public reasons = Reasons;
	private lastAnnouncement = '';

	constructor (
		@Inject('Window') private window: Window,
		private elementRef: ElementRef<HTMLElement>,
		private liveAnnouncer: LiveAnnouncer
	) {}

	public ngAfterViewChecked (): void {
		this.announceRenderedContent();
	}

	public continueWithoutAudio () {
		this.window.localStorage.setItem(CONTINUE_WITHOUT_AUDIO_KEY, 'true');
		this.status.action({ continueWithoutAudio: true });
	}

	private announceRenderedContent (): void {
		// Use rendered text so translated HTML such as <br> is announced with natural spacing.
		const announcement = this.elementRef.nativeElement.innerText.replace(/\s+/g, ' ').trim();

		if (announcement.length === 0 || announcement === this.lastAnnouncement) {
			return;
		}

		this.lastAnnouncement = announcement;
		this.liveAnnouncer.announce(announcement, 'polite');
	}
}
